import { TextField } from '@mui/material';
import { validInteger } from 'app/helpers/numberHelper';
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { usePromiseTracker } from 'react-promise-tracker';
import { useSelector } from 'react-redux';
import { selectIsEditMod, selectStandard } from 'store/redux-store/placement-mods/selectors';

interface RequiredHoursProps {
  readOnly?: boolean;
}

export const RequiredHours = ({ readOnly }: RequiredHoursProps) => {
  const { control, getValues, setValue } = useFormContext();
  const { t } = useTranslation();
  const requiredHours = 'requiredHours';
  const isModEdit = useSelector(selectIsEditMod);
  const standard = useSelector(selectStandard);
  const { promiseInProgress: isSaveModApiCalling } = usePromiseTracker({ area: 'save-mod-api', delay: 0 });

  return (
    <Controller
      control={control}
      name={requiredHours}
      render={({ field: { onChange, value, ...rest } }) => (
        <TextField
          variant="filled"
          fullWidth
          color="primary"
          id="requiredHours"
          autoComplete="off"
          label={t('placement.placementMods.requiredHours')}
          InputProps={{
            readOnly: readOnly !== undefined ? readOnly : (standard ? true : !isModEdit),
            style: {
              pointerEvents: readOnly !== undefined ? (readOnly ? 'none' : 'auto') : (standard || !isModEdit ? 'none' : 'auto'),
            },
          }}
          onChange={e => {
            const isReadOnlyField = readOnly !== undefined ? readOnly : (standard ? true : !isModEdit);
            if (!isReadOnlyField && validInteger(e.target.value, { numberLength: 4 })) {
              const validInput = e.target.value.replace(/^\./, ' ');
              setValue(requiredHours, validInput);
              onChange(validInput);
            }
          }}
          disabled={isSaveModApiCalling}
          value={getValues(requiredHours) ?? ''}
          {...rest}
        />
      )}
    />
  );
};
